<form [formGroup]="form">
  <app-domain-selector
    #appDomainSelector
    formControlName="targetDomains"
    [referenceByTypeAndKey]="true"
    [referenceKey]="pack.key"
    [referenceType]="referenceType"
    [pack]="pack"
    [setDisabled]="isTargetDomainsDisabled"
  >
  </app-domain-selector>
</form>
